define.alias("shared/utils/number-helpers/format-number-with-suffix", "calendar/utils/number-helpers/format-number-with-suffix");